/*
 * Copyright (c) 2026.
 * # Autor: TECINCO TECNOLOGIA
 * # Dev: Alejandro Meriño Rodrìguez
 * # Versión: 2.0.0
 */

export enum IconType {
    PERSON = 'person',
    OS_BUDGET = 'business',
    LOCAL_SHIPPING = 'local_shipping',
    INVENTORY = 'inventory'
}

export enum ClassType {
    CLIENTE = 'cliente',
    OS_BUDGET = 'MkgOS',
    PRODUCTO = 'producto',
    ORDEN = 'orden'
}
